import { Stack, useTheme } from "@bps/fluent-ui";
import { SectionTitle } from "@components/SectionTitle";

import { CommandAuditSection } from "./CommandAuditSection";

export const CommandAuditScreen: React.FC = () => {
  const theme = useTheme();

  return (
    <Stack
      verticalFill
      styles={{
        root: {
          padding: theme.spacing.s1,
          width: "100%",
          overflow: "hidden"
        }
      }}
      tokens={{ childrenGap: theme.spacing.m }}
    >
      <SectionTitle>Command Audit</SectionTitle>

      <CommandAuditSection />
    </Stack>
  );
};
